export default __webpack_public_path__ + "static/media/bsc-logo.92643887.png";